import bannerServices from "../Services/bannerServices";
import { showToast } from "./toast";
import { GET_BANNER, SET_FAILED_MESSAGE, SET_SUCCESS_MESSAGE } from "./type";
import { startLoaderAction, stopLoaderAction } from "./updateReducerValue";

export const addBannerAction = (payload) => (dispatch) => {
  dispatch(startLoaderAction());
  return bannerServices.addBanner(payload).then((resp) => {
    if (resp.status) {
      dispatch(showToast(resp?.data, "success"));
      dispatch(stopLoaderAction());
    } else {
      dispatch(showToast(resp?.data, "error"));
      dispatch(stopLoaderAction());
    }
    return Promise.resolve();
  });
};

export const getBannerAction = (page, limit) => async (dispatch) => {
  dispatch(startLoaderAction());
  return bannerServices.getBanner(page, limit).then((resp) => {
    if (resp.status) {
      dispatch({ type: GET_BANNER, payload: resp.data });
    } else {
      //   dispatch(showToast(resp?.data, "error"));
    }
    dispatch(stopLoaderAction());
  });
};

export const editBannerAction = (payload) => async (dispatch) => {
  dispatch(startLoaderAction());
  const resp = await bannerServices.editBanner(payload);
  if (resp.status) {
    dispatch(showToast(resp?.data, "success"));
    dispatch(stopLoaderAction());
  } else {
    dispatch(showToast(resp?.data, "error"));
    dispatch(stopLoaderAction());
  }
  return await Promise.resolve();
};
